<script>
// Renders the components that enabled modules contribute to an extension point.
//   <ext-slot name="home.sections" />
//   <ext-slot name="app.global" :props="{ foo }" />
export default {
    name: 'ExtSlot',
    functional: true,
    props: {
        name: { type: String, required: true },
        props: { type: Object, default: () => ({}) }
    },
    render(h, { props, parent }) {
        const { loggedIn, memberInfo } = parent.$sharedState;
        return parent.$modules
            .items(props.name, { loggedIn, memberInfo })
            .filter(item => item.component)
            .map(item => h(item.component, { key: item.key, props: props.props }));
    }
};
</script>
